import React, { Component } from 'react';
import { connect } from 'react-redux';

import InpcListHandlers from 'inpc/containers/InpcListHandlers';
import InpcRowContainer from 'inpc/containers/InpcRowContainer';
import * as Inpc from 'inpc/components';

import { getVisibleInpc, getPagination, getFilters, getIsLoading } from 'inpc/selectors';
import { getPermissions, getCompany } from 'auth/selectors';

class InpcListContainer extends Component {
  renderRows = () => this.props.inpc.map((inpc) => <InpcRowContainer key={inpc.id} inpc={inpc} />);
  render = () => (
    <InpcListHandlers
      render={({
        handleOrderChange,
        handlePageChange,
        handleLimitChange,
        handleFiltersChange,
        handleSubmit,
        columnSearch, // Cambiar por redux
        handleToggleSearch, // Agregar
      }) => (
        <Inpc.ListView
          count={this.props.inpc.length}
          filters={this.props.filters}
          company={this.props.company}
          isLoading={this.props.isLoading}
          handleOrderChange={handleOrderChange}
          handleSubmit={handleSubmit}
          handleFiltersChange={handleFiltersChange}
          handleToggleSearch={handleToggleSearch} // Agregar
          columnSearch={columnSearch} // Agregar - corregir por Redux
          handleLimitChange={handleLimitChange}
          handlePageChange={handlePageChange}
          subcompany={this.props.subcompany}
          pagination={this.props.pagination}
          permissions={this.props.permissions}
        >
          {this.renderRows()}
        </Inpc.ListView>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  permissions: getPermissions(state),
  inpc: getVisibleInpc(state),
  pagination: getPagination(state),
  filters: getFilters(state),
  isLoading: getIsLoading(state),
});
export default connect(mapStateToProps, null)(InpcListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/containers/InpcListContainer.js